module.exports = __webpack_public_path__ + "QRcode.jpg?616b7128ce6afbf27b6c6403c2fd59b7";